import React, { useEffect, useRef } from 'react';
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { faHistory, faTasks, faHandHoldingUsd, faMapMarkedAlt, faUserAlt, faExclamationTriangle, faMale } from '@fortawesome/free-solid-svg-icons';
import { faQuinscape } from '@fortawesome/free-brands-svg-icons';

const advantages = [
  { icon: faHistory, text: "Економія вашого часу" },
  { icon: faTasks, text: "Експертиза перевезень" },
  { icon: faQuinscape, text: "Масштабування бізнесу" },
  { icon: faHandHoldingUsd, text: "Економія ваших витрат" },
  { icon: faMapMarkedAlt, text: "Ланцюжки поставок" },
  { icon: faUserAlt, text: "Лояльність клієнтів" },
  { icon: faExclamationTriangle, text: "Управління ризиками" },
  { icon: faMale, text: "Надійний перевізник 24/7" },
];

function Icons() {
  const sectionRef = useRef(null);

  useEffect(() => {
    const observer = new IntersectionObserver(
      (entries) => {
        entries.forEach(entry => {
          if (entry.isIntersecting) {
            const items = entry.target.querySelectorAll('.adv-item');
            items.forEach((item, i) => {
              setTimeout(() => {
                item.style.opacity = '1';
                item.style.transform = 'translateY(0)';
              }, i * 80);
            });
          }
        });
      },
      { threshold: 0.2 }
    );
    if (sectionRef.current) observer.observe(sectionRef.current);
    return () => observer.disconnect();
  }, []);

  return (
    <section ref={sectionRef} style={{
      padding: '120px 24px',
      background: '#0a0a0f',
      position: 'relative',
    }}>
      <div style={{ maxWidth: 1200, margin: '0 auto' }}>
        <h2 style={{
          textAlign: 'center',
          fontSize: 'clamp(24px, 4vw, 40px)',
          fontWeight: 700,
          color: '#fff',
          marginBottom: 60,
          textTransform: 'uppercase',
          letterSpacing: '0.05em',
        }}>
          Наші <span style={{
            background: 'linear-gradient(135deg, #16b724, #4dc247)',
            WebkitBackgroundClip: 'text',
            WebkitTextFillColor: 'transparent',
          }}>переваги</span>
        </h2>

        <div className="advantages-grid" style={{
          display: 'grid',
          gridTemplateColumns: 'repeat(4, 1fr)',
          gap: 32,
        }}>
          {advantages.map((item, i) => (
            <div key={i} className="adv-item" style={{
              opacity: 0,
              transform: 'translateY(30px)',
              transition: 'all 0.5s cubic-bezier(0.4, 0, 0.2, 1)',
              display: 'flex',
              flexDirection: 'column',
              alignItems: 'center',
              textAlign: 'center',
              padding: 24,
              cursor: 'default',
            }}
            onMouseOver={e => {
              const icon = e.currentTarget.querySelector('.icon-circle');
              if (icon) {
                icon.style.boxShadow = '0 0 30px rgba(22,183,36,0.4)';
                icon.style.borderColor = '#16b724';
              }
            }}
            onMouseOut={e => {
              const icon = e.currentTarget.querySelector('.icon-circle');
              if (icon) {
                icon.style.boxShadow = 'none';
                icon.style.borderColor = 'rgba(22,183,36,0.3)';
              }
            }}
            >
              <div className="icon-circle" style={{
                width: 80,
                height: 80,
                borderRadius: '50%',
                border: '2px solid rgba(22,183,36,0.3)',
                display: 'flex',
                alignItems: 'center',
                justifyContent: 'center',
                marginBottom: 16,
                transition: 'all 0.4s ease',
                background: 'rgba(22,183,36,0.05)',
              }}>
                <FontAwesomeIcon icon={item.icon} style={{
                  color: '#4dc247',
                  fontSize: 28,
                }} />
              </div>
              <span style={{
                color: 'rgba(255,255,255,0.8)',
                fontSize: 14,
                fontWeight: 500,
                lineHeight: 1.5,
              }}>
                {item.text}
              </span>
            </div>
          ))}
        </div>
      </div>

      <style>{`
        @media (max-width: 768px) {
          .advantages-grid {
            grid-template-columns: repeat(2, 1fr) !important;
            gap: 20px !important;
          }
        }
      `}</style>
    </section>
  );
}

export default Icons;
